import React, { useEffect, useRef } from "react";

// Doopal-style flowing aurora: soft moving green gradient blobs on a light bg,
// gently reacting to the cursor. Professional and subtle.
export default function AuroraCanvas({ className = "" }) {
  const ref = useRef(null);
  const mouse = useRef({ x: 0.5, y: 0.4 });

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    const DPR = Math.min(window.devicePixelRatio || 1, 2);
    let raf, w, h, t = 0;

    const blobs = [
      { c: "rgba(20,162,75,0.28)", r: 0.42, ox: 0.30, oy: 0.32, sx: 0.6, sy: 0.5 },
      { c: "rgba(11,94,46,0.22)", r: 0.38, ox: 0.68, oy: 0.30, sx: 0.5, sy: 0.7 },
      { c: "rgba(46,200,120,0.20)", r: 0.36, ox: 0.55, oy: 0.68, sx: 0.7, sy: 0.4 },
      { c: "rgba(120,220,170,0.18)", r: 0.30, ox: 0.38, oy: 0.62, sx: 0.45, sy: 0.6 },
    ];

    const resize = () => {
      w = canvas.offsetWidth; h = canvas.offsetHeight;
      canvas.width = w * DPR; canvas.height = h * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    };

    const draw = () => {
      t += 0.004;
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = "lighter";
      for (let i = 0; i < blobs.length; i++) {
        const b = blobs[i];
        const mx = (mouse.current.x - 0.5) * 0.12;
        const my = (mouse.current.y - 0.5) * 0.12;
        const cx = (b.ox + Math.sin(t * b.sx + i) * 0.06 + mx) * w;
        const cy = (b.oy + Math.cos(t * b.sy + i) * 0.06 + my) * h;
        const rad = b.r * Math.min(w, h);
        const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, rad);
        g.addColorStop(0, b.c);
        g.addColorStop(1, "rgba(255,255,255,0)");
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(cx, cy, rad, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalCompositeOperation = "source-over";
      raf = requestAnimationFrame(draw);
    };

    const onMove = (e) => {
      const r = canvas.getBoundingClientRect();
      mouse.current = { x: (e.clientX - r.left) / r.width, y: (e.clientY - r.top) / r.height };
    };

    resize();
    draw();
    window.addEventListener("resize", resize);
    window.addEventListener("mousemove", onMove);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMove);
    };
  }, []);

  return <canvas ref={ref} className={`h-full w-full ${className}`} />;
}
